import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Derzeitiger Preis ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          "size-xl": "3",
          size: "2"
        }),
        _createVNode(_component_ion_col, {
          "size-xl": "6",
          size: "8",
          class: "center",
          style: {"padding":"0"}
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_col, {
          "size-xl": "3",
          size: "2"
        }),
        _createVNode(_component_ion_col, {
          "size-xl": "6",
          size: "8",
          class: "center",
          style: {"padding-top":"0","color":"var(--ion-headline-color)"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" ca. " + _toDisplayString(new Intl.NumberFormat('de-DE', { style: 'decimal' }).format(_ctx.store.data.calcBudgetLow)) + " € - " + _toDisplayString(new Intl.NumberFormat('de-DE', { style: 'decimal' }).format(_ctx.store.data.calcBudgetHigh)) + " € ", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}